const styles = () => ({
  container: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    minWidth: "200px",
    width: "200px",
    "& .MuiTextField-root": {
      width: "100%",
    },
    "& .MuiOutlinedInput-root": {
      width: "100%",
      paddingLeft: "4px !important",
    },
  },
});

export default styles;
